<template>
  <button
    class="jade-button"
    :class="computedClass"
    :disabled="disabled || loading"
    :type="type"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <jade-spinner
      v-if="loading"
      color="current-color"
      :size="computedIconSize"
    />
    <jade-icon
      v-else
      color="current-color"
      :use="icon"
      :size="computedIconSize"
    />

    <jade-text
      as="span"
      color="current-color"
      weight="semibold"
      :variant="computedTextVariant"
    >
      <slot />
    </jade-text>
  </button>
</template>

<script>
import SIZE_ENUM from '../enums/sizes.enum'
import BUTTON_VARIANTS from '../enums/button-variants.enum'

export default {
  name: 'jade-button',

  components: {
    JadeIcon: () => import('../JadeIcon/index.vue'),
    JadeText: () => import('../JadeText/index.vue'),
    JadeSpinner: () => import('../JadeSpinner/index.vue')
  },

  props: {
    disabled: Boolean,
    loading: Boolean,
    icon: String,
    type: {
      type: String,
      default: 'button'
    },
    variant: {
      type: String,
      validation: size => Object.values(BUTTON_VARIANTS).includes(size),
      default: BUTTON_VARIANTS.NEUTRAL_SUBTLE
    },
    size: {
      type: String,
      validation: size =>
        Object.values([
          SIZE_ENUM.LARGE,
          SIZE_ENUM.MEDIUM,
          SIZE_ENUM.SMALL
        ]).includes(size),
      default: SIZE_ENUM.LARGE
    }
  },

  computed: {
    computedClass () {
      return {
        [`is-${this.size}`]: this.size,
        [`is-${this.variant}`]: this.variant,
        'is-loading': this.loading
      }
    },
    computedIconSize () {
      return this.size === SIZE_ENUM.LARGE ? SIZE_ENUM.MEDIUM : this.size
    },
    computedTextVariant () {
      return `text-${
        this.size === SIZE_ENUM.LARGE ? this.size : SIZE_ENUM.MEDIUM
      }`
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/button.css';
</style>
